// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"92191353","553":"12b2f3bb","554":"37437711"}[chunkId] + ".chunk.js";
};